export enum BookingSource {
	Internal = 'internal',
	Yandex = 'yandex',
	Crm = 'crm_form',
	Ai = 'mcp_tools',
}
